import React from 'react';

function Stats({ stats }) {
  return (
    <div className="dashboard-grid">
      <div className="stat-card">
        <h3>Total Churches</h3>
        <div className="value">{stats.total_churches.toLocaleString()}</div>
      </div>

      <div className="stat-card">
        <h3>With Email</h3>
        <div className="value">{stats.churches_with_email.toLocaleString()}</div>
        <div style={{ fontSize: '0.85rem', color: '#7f8c8d', marginTop: '0.5rem' }}>
          {stats.total_churches > 0 
            ? `${Math.round((stats.churches_with_email / stats.total_churches) * 100)}% of total`
            : '0%'
          }
        </div>
      </div>

      <div className="stat-card">
        <h3>With Phone</h3>
        <div className="value">{stats.churches_with_phone.toLocaleString()}</div>
        <div style={{ fontSize: '0.85rem', color: '#7f8c8d', marginTop: '0.5rem' }}>
          {stats.total_churches > 0 
            ? `${Math.round((stats.churches_with_phone / stats.total_churches) * 100)}% of total`
            : '0%'
          }
        </div>
      </div>

      <div className="stat-card">
        <h3>Contacts (30 days)</h3>
        <div className="value">{stats.contacts_last_30_days.toLocaleString()}</div>
      </div>
    </div>
  );
}

export default Stats;
